import PropTypes from 'prop-types'
import classNames from 'classnames'
import '../../../styles/paypal.css'

const propTypes = {
    methods: PropTypes.array.isRequired,
    selected: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    selectedAction: PropTypes.node
}

/**
 * The radio list of PayPal-provided ways to pay. Only methods PayPal reported as eligible for
 * this merchant, buyer and currency are passed in, so the list is whatever the buyer can
 * actually complete a payment with.
 *
 * `selectedAction` replaces the brand marks on the selected row — used by the guest card flow,
 * whose button has to live in the row alongside the form it opens.
 *
 * Rows are divs rather than buttons because that action is itself interactive, and a button
 * cannot legally contain one.
 */
const PaypalMethodList = ({methods, selected, onSelect, selectedAction}) => {
    const handleKeyDown = (event, methodId) => {
        if (event.key !== 'Enter' && event.key !== ' ') return
        event.preventDefault()
        onSelect(methodId)
    }

    return (
        <div className="pp-methods" role="radiogroup" aria-label="Payment method">
            {methods.map((method) => {
                const isSelected = method.id === selected

                return (
                    <div
                        key={method.id}
                        role="radio"
                        tabIndex={0}
                        aria-checked={isSelected}
                        className={classNames('pp-method', isSelected && 'is-selected')}
                        onClick={() => onSelect(method.id)}
                        onKeyDown={(event) => handleKeyDown(event, method.id)}
                    >
                        <span className="pp-method-radio"></span>
                        <span className="pp-method-label">{method.label}</span>
                        {isSelected && selectedAction
                            ? selectedAction
                            : <span className="pp-method-mark">{method.mark}</span>}
                    </div>
                )
            })}
        </div>
    )
}

PaypalMethodList.propTypes = propTypes

export default PaypalMethodList
